export type TokenData = {
  accessToken?: string;
  refreshToken?: string;
};

export type User = {
  username: string;
  password: string;
  role: string;
  customerId: number;
  authdata?: string;
  fullname: string;
};

export type Claim = {
  dateOpened: string;
  dateClosed: string;
  vulnerability: string;
  habitation: string;
  id: number;
  claimType: string;
  claimTypeDescription: string;
  status: string;
  insuredName: string;
  claimNumber: string;
  street: string;
  suburb: string;
  city: string;
  claimProgress: string;
  recommendedReserve: number;
  contractValue: number;
  sumInsured: number;
  totalAuthorized: number;
  totalOutstandingAuthorized: number;
  totalVariations: number;
  previousPayments: number;
  lossType: string;
  claimHandler: string;
  projectManagerName: string;
  projectManagerPhoneNumber: string;
  projectManagerEmail: string;
  projectCoordinatorName: string;
  projectCoordinatorEmail: string;
  customer: string;
  urgency: number;
  eqcBuildingReserve: number;
  eqcLandReserve: number;
};

export type Task = {
  id: number;
  claimId: number;
  assignedTo: string;
  dueBy: string;
  overdue: boolean;
  topicDescription: string;
  note: string;
  orderNumber: string;
  status: string;
  insuredContact: boolean;
};

export type ProjectPlanType = {
  id: number;
  claimId: number;
  taskName: string;
  orderNumber: string;
  startDate: string;
  endDate: string;
  duration: number;
  complete: number;
  supplier: string;
  version: number;
  originalStartDate: String;
  originalEndDate: String;
};

export type Invoice = {
  id: string;
  invoiceNumber: string;
  status: string;
  price: number;
  priceAfterTax: number;
  supplier: string;
  attachments: Array<string>;
};

export type Attachment = {
  iv: number;
  attachmentType: string;
  fileNumber: number;
  filename: string;
  fileCreationDate: Date;
  fileLink: string;
  filesize: number;
  section: string;
};

export type FileUploadStatus =
  | "UPLOADED"
  | "QUEUED"
  | "INVALID_EXTENSION"
  | "FILE_TOO_LARGE"
  | "FILE_EMPTY"
  | "INVALID_METADATA"
  | "FAILED";

export type FileUploadResult = {
  status: FileUploadStatus;
  filename: string;
  message: string;
};

export type TriageDetails = {
  claimNumber: string;
  lossTypeId: number;
  company: string;
  sentDate: string;
  clickedDate: string;
  submittedDate: string;
  submittedBy: string;
  progress: string;
};

export const DEFAULT_ERROR_MESSAGE =
  "There was a server issue. Please retry or submit a Support Desk ticket.";

export const API_ERROR_CODE = {
  SRV_1000: DEFAULT_ERROR_MESSAGE, // AMBIGUOUS_USER
  SRV_1001: "Your old password is wrong! Please try again.", // INVALID_OLDPASSWORD
  SRV_1002:
    "Your new password cannot be equal to your current password! Please try again.", // NEWPASSWORD_EQUALS_OLDPASSWORD
  SRV_1003: DEFAULT_ERROR_MESSAGE, // UPDATE_PASSWORD_FAILED
  SRV_1004: DEFAULT_ERROR_MESSAGE, // NO_TOKEN_FOUND
  SRV_1005: DEFAULT_ERROR_MESSAGE, // TOKEN_EXPIRED
  SRV_1006: DEFAULT_ERROR_MESSAGE, // INVALID_TOKEN
  SRV_1007: "Your password does not match the MPS password policy.", // PASSWORD_POLICY
};
